import React, { useEffect, useState } from 'react'
import { getQuery } from '../../service/http'
import { useStores } from '@/store'
import { handleDeepLink } from '@/service/utils'
const VoucherPopUp = () => {
  const [popUpData, setPopUpData] = useState([])
  const { HomeStore } = useStores()
  const { private_token, region, lang } = getQuery()
  useEffect(() => {
    HomeStore.getHomeAdvPopup({ region, lang, private_token }).then(res => {
      if (private_token) {
        setPopUpData(res.filter(item => item.view_types === 'logged_in'))
      } else {
        setPopUpData(res.filter(item => item.view_types === 'logged_out'))
      }
    })
  }, [])

  const closePopup = function () {
    let data = [...popUpData]
    data.pop()
    setPopUpData(data)
    localStorage.setItem(`popUpData-${private_token}`, popUpData[0]?.id)
  }

  const handleClick = function () {
    closePopup()
    handleDeepLink(popUpData[0]?.client_href?.web)
  }

  return popUpData?.length ? (
    <div className='voucher-pop-up'>
      <div className='voucher-pop-up-inner'>
        <i className='icon icon-close-popup' onClick={closePopup}></i>
        <img src={popUpData[0].image} alt='' onClick={handleClick} />
      </div>
    </div>
  ) : null
}

export default VoucherPopUp
